import {
  SetupPage,
  TabPermission,
} from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { BrandSettings } from '../../../brand-settings.setup';

const parent: SetupPage = BrandSettings.pages.notifications;
const path = 'manual';
const title = 'PAGE.BRAND_SETTINGS.NOTIFICATIONS.MANUAL.TITLE';
const res = [];

export const BrandSettingsNotificationsManualTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title, res);
